import { baseAPI } from "../../baseApi";
import { tagsTypes } from "../../tagsTypes";

export const personalDetailSlice = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    postSupplierSavePrivateInformation: builder.mutation({
      query: (data) => ({
        url: "supplier-save-private-information",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [tagsTypes.GET_USER_PROFILE],
    }),
  }),
});

export const { usePostSupplierSavePrivateInformationMutation } =
  personalDetailSlice;
